<div class="page-body">
  <div
    *ngIf="
      invalidPRStateForProceeding ||
      noAvailablePaymentMethods ||
      internalServerError
    "
    class="error-wrapper"
  >
    <div class="contents-container">
      <h3
        *ngIf="noAvailablePaymentMethods || internalServerError"
        class="general-error-text"
      >
        {{ translations.errorNoAvailablePaymentsMethods }}
      </h3>
      <h3 *ngIf="invalidPRStateForProceeding" class="general-error-text">
        {{ translations.errorInvalidPRStateForProceeding }}
      </h3>
      <p class="info-text">
        {{ translations.errorInfoText }}
      </p>
    </div>
  </div>

  <div
    *ngIf="
      loading &&
      !noAvailablePaymentMethods &&
      !internalServerError &&
      !invalidPRStateForProceeding
    "
  >
    <app-spinner></app-spinner>
  </div>

  <div
    *ngIf="
      !loading &&
      !noAvailablePaymentMethods &&
      !internalServerError &&
      !invalidPRStateForProceeding
    "
    class="contents-wrapper"
  >
    <div class="contents-container">
      <app-expandable-list-item
        *ngFor="let methodVM of paymentMethodsVM"
        [title]="methodVM.title"
        [description]="methodVM.subTitle"
        [imgSrc]="methodVM.imgSrc"
        [zaverIcon]="methodVM.zaverIcon"
        [bulletPoints]="methodVM.bulletPoints"
        [color]="color"
        [selected]="methodVM === selectedPaymentMethodVM"
        [isFirstItem]="methodVM === paymentMethodsVM[0]"
        [isLastItem]="
          methodVM === paymentMethodsVM[paymentMethodsVM.length - 1]
        "
        (click)="selectPaymentMethod(methodVM)"
        [showTermsLink]="
          selectedPaymentMethodVM.type === 'INVOICE' &&
          (state.market === Market.AT || state.market === Market.DE)
        "
        [linkText]="selectedPaymentMethodVM.type === 'INVOICE' && 'AGB lesen'"
        (onTermsClick)="onTermsClick()"
      ></app-expandable-list-item>

      <div class="bottom-section-wrapper">
        <app-payment-request-info
          [lineItems]="state.paymentInformation?.lineItems"
          [value]="state.totalCheckoutValue"
          [market]="state.market"
          [language]="state.language"
          [buttonText]="translations.continueButton"
          [isButtonDisabled]="navigationInProgress"
          [merchantCustomization]="state.checkoutCustomizations"
          (onContinueClick)="handleContinueClick()"
          (onDetailsClick)="getModalPurchaseInfo()"
        ></app-payment-request-info>

        <p class="disclaimer-paragraph">
          {{ translations.disclaimer.partOne }}
          <a
            class="disclaimer-link"
            target="_blank"
            [href]="translations.links.termsOfUse"
            >{{ translations.disclaimer.partTwo }}</a
          >{{ translations.disclaimer.partThree }}
          <a
            class="disclaimer-link"
            target="_blank"
            [href]="translations.links.privacyPolicy"
            >{{ translations.disclaimer.partFour }}</a
          >
          {{ translations.disclaimer.partFive }}
          <a
            class="disclaimer-link no-wrap"
            target="_blank"
            [href]="translations.links.cookies"
            >{{ translations.disclaimer.partSix }}</a
          >{{ translations.disclaimer.partSeven
          }}<a
            *ngIf="state.market !== Market.NO && getSekkiLink()"
            class="disclaimer-link"
            target="_blank"
            [href]="getSekkiLink()"
            >{{ getPartEightDisclaimer() }}</a
          >
        </p>
      </div>
    </div>
  </div>
</div>

<zaver-checkout-modal
  *ngIf="modalActive"
  [buttonText]="translations.closeButton"
  logo="assets/img/Zaver_Logotype_Circle_Coal_DE.svg"
  (onClose)="deactivateModal()"
>
  <app-selector
    #selector
    *ngIf="selectorItems"
    [selectorItems]="selectorItems"
    [selectedItem]="selectedItem"
  ></app-selector>
</zaver-checkout-modal>
